import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  DatePicker,
  Upload,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBasePath } from "../../../components/NavigatePath";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import axios from "axios";
import UploadProfilePicture from "../../../components/UploadProfilePicture";

function ViewMedicines() {
  const user = useSelector((state) => state.user.user);
  const userType = Number(user.roleDetails.id);
  const hasRedirected = useRef(false);
  const [form] = Form.useForm();
  const location = useLocation();
  const data = location.state?.data;
  const { TextArea } = Input;
  const navigate = useNavigate();
  const basePath = useBasePath();
  const accessToken = useSelector((state) => state.user.accessToken);
  const API_URL = import.meta.env.VITE_API_URL;
  const [imageUrl, setImageUrl] = useState("");

  // Check if data is undefined and navigate
  useEffect(() => {
    if (data === undefined && !hasRedirected.current) {
      message.error("Data not found.");
      hasRedirected.current = true;
      navigate(`/${basePath}/medicines`);
    } else {
      // Populate form with existing data
      form.setFieldsValue({
        ...data,
        expiryDate: data?.expiryDate ? dayjs(data.expiryDate) : null,
      });
    }
  }, [data, navigate, basePath, form]);
  console.log(data);

  const handleSubmit = async (values) => {
    console.log(values);
    const supplierContact = String(values.supplierContact);

    const payload = {
      ...values,
      supplierContact: supplierContact,
      image: imageUrl != "" ? imageUrl : values.image,
      type: values.type,
      dose: values.dose,
    };
    try {
      const response = await axios.patch(
        `${API_URL}Medicines?id=${data.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      console.log(response);
      message.success("Data saved successfully.");
      navigate(`/${basePath}/medicines`);
    } catch (error) {
      console.error("Error saving data:", error);
      message.error("Failed to save data.");
    }
  };
  const handleFileChange = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      form.setFieldsValue({ image: reader.result });
    };
    reader.readAsDataURL(file);
    message.success("Image selected successfully!");
  };

  const handleCancel = () => {
    form.resetFields();
    navigate(-1);
  };
  const uploadButton = (
    <div>
      <PlusOutlined />
    </div>
  );
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ width: "100%" }}
        disabled={userType !== 1}
      >
        <div className="flex flex-row bg-white p-10 rounded-sm space-x-24">
          <div className={`w-[15%] flex flex-col items-center space-y-6 `}>
           
            <UploadProfilePicture
              disabled={userType !== 1}
              value={data.image}
              onChange={(url) => {
                setImageUrl(url);
              }}
            />

            <p className="text-2xl font-bold">
              {" "}
              {data?.name || "No Title Available"}
            </p>
            <p className="text-2xl font-bold"> {data?.name_ar || ""}</p>
            <div className="flex flex-col space-y-5">
              <Form.Item label="Strength" name="strength" className="m-0">
                <Input defaultValue={data?.strength || "N/A"} />
              </Form.Item>
              <Form.Item 
                label="Dose" 
                name="dose" 
                className="m-0"
              >
                <Input 
                  placeholder="Enter dose"
                  defaultValue={data?.dose}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item label="Type" name="type" className="m-0">
                <Select 
                  defaultValue={data?.type || "N/A"}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Select.Option value="Capsule">Capsule</Select.Option>
                  <Select.Option value="Tablet">Tablet</Select.Option>
                  <Select.Option value="Cream">Cream</Select.Option>
                  <Select.Option value="Syrup">Syrup</Select.Option>
                  <Select.Option value="Drops">Drops</Select.Option>
                  <Select.Option value="Inhalers">Inhalers</Select.Option>
                  <Select.Option value="Injections">Injections</Select.Option>
                  <Select.Option value="Tablets">Tablets</Select.Option>
                  <Select.Option value="Capsules">Capsules</Select.Option>
                  <Select.Option value="Ointmaint">Ointmaint</Select.Option>
                  <Select.Option value="Eye drops">Eye drops</Select.Option>
                  <Select.Option value="Ear drops">Ear drops</Select.Option>
                  <Select.Option value="Sachets">Sachets</Select.Option>
                  <Select.Option value="Spray">Spray</Select.Option>
                  <Select.Option value="Suppsitory">Suppsitory</Select.Option>
                  <Select.Option value="Facial wash">Facial wash</Select.Option>
                  <Select.Option value="Gel">Gel</Select.Option>
                  <Select.Option value="Lotion">Lotion</Select.Option>
                  <Select.Option value="Caplets">Caplets</Select.Option>
                  <Select.Option value="Ampoules">Ampoules</Select.Option>
                  <Select.Option value="Soap">Soap</Select.Option>
                  <Select.Option value="Hair oil">Hair oil</Select.Option>
                  <Select.Option value="Suspention">Suspention</Select.Option>
                  <Select.Option value="Vaginal Suppsitory">Vaginal Suppsitory</Select.Option>
                  <Select.Option value="Vaginal Gel">Vaginal Gel</Select.Option>
                  <Select.Option value="Oral Drops">Oral Drops</Select.Option>
                  <Select.Option value="Shampoo">Shampoo</Select.Option>
                  <Select.Option value="Vial">Vial</Select.Option>
                  <Select.Option value="Infusion">Infusion</Select.Option>
                  <Select.Option value="Cartiridges">Cartiridges</Select.Option>
                  <Select.Option value="Prefilled pen">Prefilled pen</Select.Option>
                  <Select.Option value="Powder">Powder</Select.Option>
                  <Select.Option value="Inhaler">Inhaler</Select.Option>
                  <Select.Option value="Eye OINT">Eye OINT</Select.Option>
                  <Select.Option value="Serum">Serum</Select.Option>
                  <Select.Option value="Mouth wash">Mouth wash</Select.Option>
                  <Select.Option value="Nasal drops">Nasal drops</Select.Option>
                  <Select.Option value="SOLUTION">SOLUTION</Select.Option>
                  <Select.Option value="Vaginal Douch">Vaginal Douch</Select.Option>
                  <Select.Option value="Gummies">Gummies</Select.Option>
                  <Select.Option value="Chewable">Chewable</Select.Option>
                  <Select.Option value="LOZENGES">LOZENGES</Select.Option>
                  <Select.Option value="Effervescent">Effervescent</Select.Option>
                  <Select.Option value="Vaginal cream">Vaginal cream</Select.Option>
                  <Select.Option value="Eye ointmaint">Eye ointmaint</Select.Option>
                  <Select.Option value="Eye gel">Eye gel</Select.Option>
                  <Select.Option value="Conditioner">Conditioner</Select.Option>
                  <Select.Option value="Foam">Foam</Select.Option>
                  <Select.Option value="PENFILLS">PENFILLS</Select.Option>
                  <Select.Option value="PREFILLED SYRINGE">PREFILLED SYRINGE</Select.Option>
                  <Select.Option value="PATCHES">PATCHES</Select.Option>
                  <Select.Option value="LUBRICANT">LUBRICANT</Select.Option>
                  <Select.Option value="WHITENING WASH">WHITENING WASH</Select.Option>
                  <Select.Option value="FACIAL CLEANSER">FACIAL CLEANSER</Select.Option>
                  <Select.Option value="FILM">FILM</Select.Option>
                  <Select.Option value="FLEXPEN">FLEXPEN</Select.Option>
                  <Select.Option value="POUCHES">POUCHES</Select.Option>
                  <Select.Option value="NASAL SPRAY">NASAL SPRAY</Select.Option>
                  <Select.Option value="HAIR MASK">HAIR MASK</Select.Option>
                  <Select.Option value="SHEETS">SHEETS</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item label="Category" name="category" className="m-0">
                <Input defaultValue={data?.category || "N/A"} />
              </Form.Item>
              <Form.Item label="SKU" name="SKU" className="m-0">
                <Input defaultValue={data?.SKU || "N/A"} />
              </Form.Item>
            </div>
          </div>
          <div className="w-[85%]">
            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">Manufacturer</span>
                  }
                  name="manufacturer"
                >
                  <Input style={{ height: "40px" }} />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">Reorder Level</span>
                  }
                  name="recorderLevel"
                >
                  <Input style={{ height: "40px" }} />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">Batch Number</span>
                  }
                  name="batchNumber"
                >
                  <InputNumber
                    className="no-arrows"
                    style={{ width: "100%", height: "40px" }}
                  />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Prescription Status
                    </span>
                  }
                  name="prescriptionStatus"
                  rules={[
                    {
                      required: true,
                      message: "Please select a prescription status",
                    },
                    () => ({
                      validator(_, value) {
                        if (value === true || value === false) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Prescription status must be true or false")
                        );
                      },
                    }),
                  ]}
                >
                  <Select
                    placeholder="Select prescription status"
                    style={{ height: "40px" }}
                  >
                    <Select.Option value={true}>True</Select.Option>
                    <Select.Option value={false}>False</Select.Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Stock Quantity
                    </span>
                  }
                  name="stackQuantity"
                >
                  <Input style={{ height: "40px" }} />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Storage condition
                    </span>
                  }
                  name="storageCondition"
                >
                  <Input style={{ height: "40px" }} />
                </Form.Item>
              </div>
            </div>

            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">Expiry Date</span>
                  }
                  name="expiryDate"
                >
                  <DatePicker
                    prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                    suffixIcon={null}
                    placeholder=""
                    style={{ width: "100%", height: "40px" }}
                  />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">Supplier Name</span>
                  }
                  name="supplierName"
                >
                  <Input style={{ height: "40px" }} />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Supplier Contact
                    </span>
                  }
                  name="supplierContact"
                >
                  <InputNumber
                    className="no-arrows"
                    style={{ width: "100%", height: "40px" }}
                  />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Price per unit
                    </span>
                  }
                  name="pricePerUnit"
                >
                  <Input style={{ height: "40px" }} />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Quantity per Package
                    </span>
                  }
                  name="quantityPerPackage"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter a Quantity Per Package",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter quantity per package"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      How To Use (EN)
                    </span>
                  }
                  name="howToUse"
                  rules={[
                    { required: true, message: "Please Enter a How To Use" },
                  ]}
                >
                  <Input
                    placeholder="Enter How To Use"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      How To Use (AR)
                    </span>
                  }
                  name="howToUse_ar"
                  rules={[
                    { required: true, message: "Please Enter a How To Use" },
                  ]}
                >
                  <Input
                    placeholder="Enter How To Use"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Side Effects (EN)
                    </span>
                  }
                  name="sideEffects"
                  rules={[
                    { required: true, message: "Please Enter a Side Effects" },
                    {
                      whitespace: true,
                      message: "No white Space",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter quantity per package"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Side Effects (AR)
                    </span>
                  }
                  name="sideEffects_ar"
                  rules={[
                    { required: true, message: "Please Enter a Side Effects" },
                    {
                      whitespace: true,
                      message: "No white Space",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter quantity per package"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Description (EN)
                    </span>
                  }
                  name="description"
                  rules={[
                    { required: true, message: "Please Enter a Description" },
                    {
                      whitespace: true,
                      message: "No white Space",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter quantity per package"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
              <div className="flex-1">
                <Form.Item
                  label={
                    <span className="text-base font-normal">
                      Description (AR)
                    </span>
                  }
                  name="description_ar"
                  rules={[
                    { required: true, message: "Please Enter a Description" },
                    {
                      whitespace: true,
                      message: "No white Space",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter quantity per package"
                    style={{ height: "40px" }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex-1 w-full">
                <Form.Item
                  label={
                    <span className="text-base font-normal">Interactions</span>
                  }
                  name="interactions"
                >
                  <TextArea rows={6} />
                </Form.Item>
              </div>
            </div>

            <div className="flex justify-end mt-6">
              {userType === 1 && (
                <>
                  <Button
                    type="default"
                    onClick={handleCancel}
                    style={{ marginRight: 10 }}
                  >
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Save
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default ViewMedicines;
